import { environment } from '../../environments/environment';

const PLATFORM_HOSTS = new Set([
  'portaldev.ef-it.nl',
  'admin.portal.ef-it.nl',
  'portal.ef-it.nl',
  'localhost',
  '127.0.0.1']);

/**
 * On white-label custom FQDNs, use same-origin /api/v1 so Traefik routes API on the branded Host.
 * Mutates environment.apiUrl once at bootstrap.
 */
export function applyWhiteLabelApiBase(): void {
  if (typeof window === 'undefined' || !window.location?.host) {
    return;
  }

  const host = window.location.host.toLowerCase().split(':')[0];
  if (!host || PLATFORM_HOSTS.has(host)) {
    return;
  }

  // Custom portal hostname → same-origin API
  (environment as { apiUrl: string }).apiUrl = `${window.location.origin}/api/v1`;
}

export function isCustomPortalHost(): boolean {
  if (typeof window === 'undefined' || !window.location?.host) {
    return false;
  }
  const host = window.location.host.toLowerCase().split(':')[0];
  return !!host && !PLATFORM_HOSTS.has(host);
}
